import CustomerListResultModelBase from '../_generated/modelBases/customer-list-result-model-base';

export default class CustomerListResultModel extends CustomerListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
